<!-- 外卖菜品页面 -->
<template>
  <div class="home flexBox" v-if="isAll">
    <!-- :title="$t('Dishes.title')" -->
    <van-nav-bar
      :style="{ background: sessionStorage.colorCode }"
      left-arrow
      fixed
      @click-left="
        $router.push(
          '/Home/' + sessionStorage.storeId + '/book/' + sessionStorage.code
        )
      "
    >
      <template #title>
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="value1"
            :options="option1"
            @change="localeChange"
          />
        </van-dropdown-menu>
      </template>
    </van-nav-bar>
    <div class="shopTitle">
      <div style="display: flex; align-items: center;">
        <van-icon
          v-if="shopInfos.image.path"
          :name="shopInfos.image.path"
          size="50px"
        />
        <van-icon v-else name="./static/img/SHOPLOGO.png" size="50px" />
        <span>{{ shopInfos.name }}</span>
      </div>
      <div style="font-size: 16px;font-weight: 600;">
        {{ $t("MealNum.delivery") }}
      </div>
    </div>
    <div class="contentWrapper">
      <div v-if="dishes" class="menuContent">
        <van-sidebar v-model="activeKey" @change="changeKey()">
          <div v-for="(dish, index) in dishes" :key="index">
            <van-sidebar-item
              v-if="dish.status"
              :title="dish.name"
              :style="
                activeKey == index
                  ? {
                      'background-color': sessionStorage.colorCode,
                      'border-color': sessionStorage.colorCode
                    }
                  : {}
              "
            ></van-sidebar-item>
          </div>
        </van-sidebar>
        <div class="dishContent">
          <!-- 有产品 -->
          <template v-if="actMenus.length > 0">
            <div
              v-for="(menu, index) in actMenus"
              class="dishItem"
              :key="menu.id"
            >
              <div
                @click.stop="
                  menu.category == 'm'
                    ? $router.push('/TakeDishDetail/' + menu.id)
                    : $router.push('/TakePackageDetail/' + menu.id)
                "
              >
                <template v-if="menu.image">
                  <van-image class="noflex" :src="menu.image.path" />
                </template>
                <template v-else>
                  <van-image class="noflex" :src="sessionStorage.images" />
                </template>
              </div>
              <div
                class="itemInfo"
                @click.stop="
                  menu.category == 'm'
                    ? $router.push('/TakeDishDetail/' + menu.id)
                    : $router.push('/TakePackageDetail/' + menu.id)
                "
              >
                <div class="leftInfo">
                  <div class="fontLine noExceed Bigfont">{{ menu.name }}</div>
                  <div class="fontLine noExceed Subname">
                    {{ menu.name_en }}
                  </div>
                  <div
                    class="fontLine noExceed Subname"
                    v-if="menu.introduction"
                  >
                    {{ menu.introduction }}
                  </div>
                  <div style="height: 5px;"></div>
                  <!-- <van-rate
                    readonly
                    v-model="menu.level"
                    :size="12"
                    gutter="1px"
                    icon="./static/img/Recommend-s.png"
                    void-icon="./static/img/Recommend.png"
                  /> -->
                  <div class="dishItem_footer">
                    <!-- 价格 -->
                    <div class="fontLine noExceed price_num">
                      <div
                        v-if="
                          menu.original_price || menu.special_price !== null
                        "
                      >
                        <span class="currentPrice">
                          <span class="priceIcon">
                            {{ sessionStorage.getItem("currency") }}
                          </span>
                          {{
                            menu.type == "o"
                              ? menu.original_price
                              : menu.special_price
                          }}
                        </span>
                        &nbsp;
                        <span class="oldPrice" v-show="menu.type == 's'">
                          <span class="priceIcon">
                            {{ sessionStorage.getItem("currency") }}
                          </span>
                          {{ menu.original_price }}
                        </span>
                      </div>
                      <div class="currentPrice" v-else>
                        <span class="priceIcon">
                          {{ sessionStorage.getItem("currency") }}
                        </span>
                        0
                      </div>
                    </div>
                    <!-- 进步器 -->
                    <div
                      class="icons"
                      v-if="sessionStorage.getItem('is_quick') == '1'"
                      @click.stop
                    >
                      <van-stepper
                        style="background: #fff;"
                        default-value="0"
                        min="0"
                        integer
                        v-model="menu.count"
                        button-size="22"
                        @plus="addDish(menu.id, index, 1)"
                        @minus="subDish(menu.id, index, 1)"
                        @focus="focusDish($event, menu.id, index, menu.count)"
                        @blur="blurDish(menu.id, index, menu.count)"
                        ref="input"
                        allow-empty
                      />
                    </div>
                  </div>
                </div>
                <!-- <div
                  class="enterIcon"
                  @click.stop="
                    menu.category == 'm'
                      ? $router.push('/TakeDishDetail/' + menu.id)
                      : $router.push('/TakePackageDetail/' + menu.id)
                  "
                >
                  <van-icon name="./static/img/View_orders.png" size="16px" />
                </div> -->
              </div>
            </div>
          </template>
          <!-- 没产品 -->
          <template v-else>
            <div style="text-align: center; line-height: 80px;">
              {{ $t("Dishes.nonefood") }}
            </div>
          </template>
        </div>
      </div>
      <!-- 购物车菜品 -->
      <van-popup
        class="ShopCartBox"
        v-model="isShopCartShow"
        position="bottom"
        :style="{ height: '75%' }"
      >
        <van-cell-group class="cartHeader">
          <van-cell>
            <div
              style="font-size: 18px; font-weight: 600; color: #000"
              slot="title"
            >
              <van-icon
                slot="left-icon"
                name="./static/img/toback.png"
                size="16px"
                @click="isShopCartShow = false"
              />
              <!-- {{ $t("Dishes.cart") }} -->
              {{ $t("Dishes.myCart") }}[ {{ shopCart.count }} ]
            </div>
            <van-icon
              slot="right-icon"
              name="./static/img/empty.png"
              size="26px"
              @click="chearShopcart"
            />
          </van-cell>
        </van-cell-group>
        <div class="cartDetail" v-if="shopCart.data">
          <template v-for="(dish, index) in shopCart.data">
            <div class="cartItem" :key="index">
              <!-- 产品 -->
              <div class="cart_dish">
                <div class="dish noExceed">
                  <template v-if="dish.image">
                    <van-image
                      class="menuImg"
                      width="70"
                      height="70"
                      :src="dish.image.path"
                    />
                  </template>
                  <template v-else>
                    <van-image
                      class="menuImg"
                      width="70"
                      height="70"
                      :src="sessionStorage.images"
                    />
                  </template>
                  <div style="margin-left: 10px; width: calc(100% - 80px);">
                    <div class="menu_name">{{ dish.menu_name }}</div>
                    <div class="cart_dish_des noExceed">
                      <template
                        v-if="dish.menus_name.length == 0 && dish.tags_name"
                      >
                        <span
                          v-for="(tagName, index) in dish.tags_name"
                          :key="index"
                        >
                          {{ tagName }}，
                        </span>
                      </template>
                      <span
                        v-if="
                          dish.menus_name.length == 0 && dish.remark[0] != ''
                        "
                        >{{ $t("PackageDetail.remark") }}：</span
                      >
                      <template
                        v-if="
                          dish.menus_name.length == 0 && dish.remark[0] != ''
                        "
                      >
                        ({{ dish.remark[0] }})
                      </template>
                    </div>
                    <div
                      style="display: flex; align-items: center; justify-content: space-between;"
                    >
                      <div class="realPrice">
                        {{ sessionStorage.getItem("currency") }}{{ dish.price }}
                      </div>
                      <!-- 加减和价格 -->
                      <div class="icon_group">
                        <div class="cart_dish_icon fl">
                          <van-icon
                            class="reduceBtn"
                            :style="{
                              border: `1px solid ${sessionStorage.colorCode}`
                            }"
                            name="./static/img/reduce.png"
                            size="10px"
                            @click="subShopCart(dish.id, dish.number)"
                          ></van-icon>
                          <span
                            style="
                              display: inline-block;
                              min-width: 30px;
                              height: 30px;
                              text-align: center;
                              line-height: 30px;
                              vertical-align: top;
                            "
                          >
                            {{ dish.number }}
                          </span>
                          <van-icon
                            class="addBtn"
                            :style="{ background: sessionStorage.colorCode }"
                            name="./static/img/add.png"
                            size="12px"
                            @click="addShopCart(dish.id)"
                          ></van-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 套餐 -->
                <div v-if="dish.menus_name">
                  <div
                    class="cart_dish son_dish"
                    v-for="(menu, key) in dish.menus_name"
                    :key="key"
                  >
                    <div
                      v-if="typeof menu == 'object'"
                      class="cart_dish_name noExceed fl"
                    >
                      <template v-for="(menuArr, i) in menu">
                        {{ menuArr }}{{ i == menu.length - 1 ? "" : "、" }}
                      </template>
                    </div>
                    <div v-else class="cart_dish_name noExceed fl">
                      {{ menu }}
                    </div>

                    <div
                      v-if="typeof menu == 'object'"
                      class="cart_dish_price noExceed fl"
                    >
                      {{ sessionStorage.getItem("currency") }}
                      <template v-for="(priceArr, j) in dish.fill_price[key]">
                        {{ j == 0 ? priceTotal(dish.fill_price[key]) : "" }}
                      </template>
                    </div>
                    <div v-else class="cart_dish_price noExceed fl">
                      {{ sessionStorage.getItem("currency")
                      }}{{ dish.fill_price[key] }}
                    </div>
                    <div class="cart_dish_des noExceed fl">
                      <template v-if="dish.tags_name[key]">
                        <template v-if="typeof dish.tags_name[key] == 'object'">
                          <template v-for="(tagName, i) in dish.tags_name[key]">
                            <template v-if="typeof tagName == 'object'">
                              {{ arrShow(tagName) }}
                            </template>
                            <template v-else>
                              {{ tagName }}
                            </template>
                            <template v-if="dish.remark[key][i]">
                              ({{ dish.remark[key][i]
                              }}{{
                                i == dish.remark[key].length - 1 ||
                                !dish.remark[key][i]
                                  ? ""
                                  : ""
                              }})
                            </template>
                            &nbsp;&nbsp;
                          </template>
                        </template>
                        <template v-else>
                          {{ dish.tags_name[key] }}
                          <template v-if="dish.remark[key]">
                            ({{ dish.remark[key] }})
                          </template>
                        </template>
                      </template>
                    </div>
                  </div>
                </div>
                <!-- <div v-if="dish.menus_name" class="cart_dish_price noExceed fl">
                  {{ sessionStorage.getItem("currency") }}
                  {{ dish.original_price / dish.number }}
                </div> -->
              </div>
            </div>
            <van-divider style="margin: 10px 0;" />
          </template>
          <div style="height: 50px;"></div>
        </div>
        <van-tabbar
          :fixed="true"
          style="background: #fff; box-shadow: 0px 0px 10px #979797; padding: 0px 0px 10px;"
        >
          <div
            style="width: 88%; height: 45px; padding: 10px 0px 0px; margin: 8px auto; overflow: hidden;"
          >
            <div class="cart_left" @click="isShopCartShow = true">
              <van-badge :content="shopCart.count">
                <svg-icon
                  :style="{
                    width: '34px',
                    height: '34px',
                    filter: `drop-shadow(${sessionStorage.colorCode} 100px 0)`,
                    transform: 'translateX(-100px)'
                  }"
                  iconClass="cart"
                  class="icon"
                />
              </van-badge>
            </div>
            <div class="cart_right">
              <div
                class="fl total_price"
                :style="{ color: sessionStorage.colorCode }"
              >
                {{ sessionStorage.getItem("currency") }}{{ shopCart.total }}
              </div>
              <!-- 下单按钮 -->
              <van-button
                :color="sessionStorage.colorCode"
                class="cart_right_btn"
                round
                @click="cook()"
              >
                OK
              </van-button>
            </div>
          </div>
        </van-tabbar>
      </van-popup>
      <!-- 底部固定购物车栏 -->
      <van-tabbar
        :fixed="true"
        style="background: #fff; box-shadow: 0px 0px 10px #979797; padding: 0px 0px 10px;"
      >
        <div
          style="width: 88%; height: 45px; padding: 10px 0px 0px; margin: 8px auto; overflow: hidden;"
        >
          <div class="cart_left" @click="isShopCartShow = true">
            <van-badge :content="shopCart.count">
              <svg-icon
                :style="{
                  width: '34px',
                  height: '34px',
                  filter: `drop-shadow(${sessionStorage.colorCode} 100px 0)`,
                  transform: 'translateX(-100px)'
                }"
                iconClass="cart"
                class="icon"
              />
            </van-badge>
          </div>
          <div class="cart_right">
            <div
              class="fl total_price"
              :style="{ color: sessionStorage.colorCode }"
            >
              {{ sessionStorage.getItem("currency") }}{{ shopCart.total }}
            </div>
            <!-- 下单按钮 -->
            <van-button
              :color="sessionStorage.colorCode"
              class="cart_right_btn"
              round
              @click="cook()"
            >
              <!-- {{ $t("Dishes.order") }} -->
              OK
            </van-button>
          </div>
        </div>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dishes: [],
      activeKey: 0,
      actMenus: [],
      isAll: false,
      isShopCartShow: false,
      shopCart: {},
      count: 4,
      image: {},
      shopInfos: {},
      value1: 0,
      option1: [
        { text: "简体中文", value: 0 },
        { text: "繁体中文", value: 1 },
        { text: "English", value: 2 }
      ],
      timer: null //定时器
    };
  },
  async mounted() {
    await this.getShopInfo();
    await this.getShopCart();
    await this.getDishes();
    this.shopInfos = JSON.parse(sessionStorage.shopInfos);
    console.log(this.shopInfos);
    this.$i18n.locale = sessionStorage.locale;
    this.value1 =
      sessionStorage.locale == "zh" ? 0 : sessionStorage.locale == "hk" ? 1 : 2;
    console.log(sessionStorage.locale, "当前语言");
    // console.log(this.$i18n.locale, "当前语言");
    // this.shopNumber();
    this.timer = setInterval(() => {
      this.$nextTick(() => {
        this.$el.style.setProperty(
          "--background-color",
          sessionStorage.colorCode
        );
        const stepper = this.$refs.input[0];
        const plusButton = stepper.$el.querySelector(".van-stepper__plus");
        if (plusButton) {
          const style = window.getComputedStyle(plusButton);
          const backgroundColor = style.backgroundColor;
          console.log("Background color:", backgroundColor);
          if (backgroundColor != "rgb(85, 85, 85)") {
            this.timer = clearInterval(this.timer);
            this.timer = null;
            console.log(this.timer);
          }
        } else {
          console.log("Element with class .van-stepper__plus not found");
        }
      });
    }, 1000);
    console.log(this.timer);
  },
  computed: {
    priceTotal() {
      return function(arr) {
        var sum = 0;
        for (var i in arr) {
          sum += Number(arr[i]);
        }
        return sum;
      };
    },
    arrShow() {
      return function(arr) {
        var str = "";
        for (var i in arr) {
          str += arr[i] + (i == arr.length - 1 || !arr[i] ? "" : ",");
        }
        return str;
      };
    }
  },
  methods: {
    localeChange() {
      console.log(this.value1);
      let locale = "";
      locale = this.value1 == 0 ? "zh" : this.value1 == 1 ? "hk" : "en";
      this.$i18n.locale = locale;
      console.log(this.$i18n.locale);
      sessionStorage.setItem("locale", locale);
    },
    //获取店铺信息
    getShopInfo() {
      this.$axios({
        method: "get",
        headers: {
          code: sessionStorage.code
        },
        url:
          this.$build + "/api/store/" + sessionStorage.storeId + "/customerShow"
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            this.image = res.data.data.image;
            sessionStorage.setItem("currency", res.data.data.currency.unit);
            sessionStorage.setItem("is_quick", res.data.data.is_quick);
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 获取全部菜品
    getDishes() {
      this.$axios({
        method: "get",
        url:
          this.$build + "/api/store/" + sessionStorage.storeId + "/takeMenus/in"
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            let dishes = [];
            res.data.data.forEach(item => {
              if (item.status == 1) {
                dishes.push(item);
              }
            });
            this.dishes = dishes;
            this.actMenus = this.dishes[this.activeKey].menus;
            if (this.shopCart.data) {
              this.dishes.forEach(item => {
                item.menus.forEach(menu => {
                  this.shopCart.data.forEach(shop => {
                    if (menu.id === shop.menu_id) {
                      console.log(menu);
                      menu.count = shop.number;
                    }
                  });
                });
              });
            }
            console.log("查看数据", this.actMenus);
            this.isAll = true;
            // this.getShopCart();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 切换选中栏
    changeKey() {
      this.actMenus = this.dishes[this.activeKey].menus;
      sessionStorage.setItem("activeKey", this.activeKey);
      setTimeout(() => {
        this.$refs.input.forEach(d => {
          d.$refs.input.nextElementSibling.style.background =
            sessionStorage.colorCode;
        });
      }, 0);
    },
    // 保存上次选择的tab栏选项
    getActiveKey() {
      // console.log(sessionStorage.getItem("activeKey"));
      if (sessionStorage.getItem("activeKey")) {
        this.activeKey = Number(sessionStorage.getItem("activeKey"));
      } else {
        this.activeKey = 0;
      }
    },
    // 获取购物车
    getShopCart() {
      this.$axios({
        method: "post",
        url: this.$build + "/api/place/takeShopcart",
        data: {
          code: localStorage.getItem("onlyCode")
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.shopCart = res.data;
            this.shopCart.data.forEach(item => {
              let arr = [];
              console.log(
                item.menus_name,
                item.menus_name.length != 0,
                item.tags_name
              );
              if (item.menus_name.length != 0 && item.tags_name) {
                // 套餐偏好重新排版
                item.tags_name.forEach((i, num) => {
                  if (i != "" || i.length != 0) {
                    i.forEach((j, index) => {
                      let list = []; //临时存储
                      if (i.length > 1) {
                        list.push(`(${item.menus_name[num][index]})：`);
                      }
                      if (typeof j == "object") {
                        j.forEach(tag => {
                          list.push(tag);
                        });
                      } else {
                        list.push(j);
                      }
                      i.splice(index, 1, list);
                    });
                  }
                });
              } else if (item.menus_name.length == 0 && item.tags_name) {
                // 单品偏好重新排版
                if (item.tags_name[0] != "") {
                  item.tags_name.forEach(i => {
                    if (i != "" || i.length != 0) {
                      i.forEach(j => {
                        if (typeof j == "object") {
                          j.forEach(tag => {
                            arr.push(tag);
                          });
                        } else {
                          arr.push(j);
                        }
                      });
                    }
                  });
                }
                item.tags_name = arr;
              }
            });
          } else {
            // 购物车为空提示
            // for (var item in res.data.error) {
            //   this.$toast({
            //     duration: 1000,
            //     type: "fail",
            //     message: res.data.error[item]
            //   });
            // }
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 增加商品
    addShopCart(id) {
      let that = this;
      this.$axios({
        method: "PATCH",
        url: this.$build + "/api/shopcart/" + id + "/takeUpdate",
        data: {
          type: "add"
        }
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            async function get() {
              await that.getShopCart();
              await that.getDishes();
            }
            get();
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                duration: 1000,
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 减少商品
    subShopCart(id, number) {
      if (number == 1) {
        this.$dialog
          .confirm({
            title: this.$t("Dishes.del"),
            message: this.$t("Dishes.isDel"),
            confirmButtonColor: "#FFC813",
            confirmButtonText: this.$t("vantText.confirm"),
            cancelButtonText: this.$t("vantText.cancel")
          })
          .then(() => {
            this.$axios({
              method: "PATCH",
              url: this.$build + "/api/shopcart/" + id + "/takeUpdate",
              data: {
                type: "reduce"
              }
            })
              .then(res => {
                // console.log(res);
                if (res.data.status == 200) {
                  this.getShopCart();
                  this.getDishes();
                } else {
                  this.$toast.allowMultiple();
                  for (var item in res.data.error) {
                    this.$toast({
                      duration: 1000,
                      type: "fail",
                      message: res.data.error[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  duration: 1000,
                  type: "fail",
                  message: this.$t("common.message")
                });
              });
          })
          .catch(() => {});
      } else {
        this.$axios({
          method: "PATCH",
          url: this.$build + "/api/shopcart/" + id + "/takeUpdate",
          data: {
            type: "reduce"
          }
        })
          .then(res => {
            // console.log(res);
            if (res.data.status == 200) {
              this.getShopCart();
              this.getDishes();
            } else {
              this.$toast.allowMultiple();
              for (var item in res.data.error) {
                this.$toast({
                  duration: 1000,
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              duration: 1000,
              type: "fail",
              message: this.$t("common.message")
            });
          });
      }
    },
    // 下单
    cook() {
      if (this.shopCart.count >= 1) {
        // this.$router.push('/Address');
        this.$router.push("/TakeCartDetail");
      } else {
        this.$toast("购物车为空");
      }
    },
    prepend(arr, item) {
      var m = [item];
      [].push.apply(m, arr);
      return m;
    },
    addDish(id, index, number) {
      this.$axios({
        method: "POST",
        url: this.$build + "/api/shopcart/takeCreated",
        data: {
          code: localStorage.getItem("onlyCode"),
          menu_id: id,
          number
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.getShopCart();
            this.getDishes();
            // this.actMenus[index].count = this.actMenus[index].count + 1;
            this.$toast({
              type: "success",
              message: res.data.message,
              duration: 1000
            });
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                duration: 1000,
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          // this.$toast({
          //   duration: 1000,
          //   type: "fail",
          //   message: this.$t("common.message")
          // });
        });
    },
    subDish(id, index, number) {
      this.$axios({
        method: "POST",
        url: this.$build + "/api/shopcart/takeReduced",
        data: {
          code: localStorage.getItem("onlyCode"),
          menu_id: id,
          number
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.getShopCart();
            this.getDishes();
            // this.actMenus[index].count = this.actMenus[index].count - 1;
            this.$toast({
              type: "success",
              message: res.data.message,
              duration: 1000
            });
          } else {
            this.$toast.allowMultiple();
            // for (var item in res.data.error) {
            //   this.$toast({
            //     duration: 1000,
            //     type: "fail",
            //     message: res.data.error[item]
            //   });
            // }
          }
        })
        .catch(err => {
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 输入框聚焦时触发
    focusDish(e, id, index, count) {
      let obj = e.srcElement;
      obj.focus();
      const len = obj.value.length;
      //光标定位要加上 setTimeOut，不然就会重新光标定位失败
      setTimeout(() => {
        obj.selectionStart = obj.selectionEnd = len;
      }, 60);
    },
    // 输入框失焦时触发
    blurDish(id, index, count) {
      console.log("失焦");
      let beforeCount = 0;
      if (this.shopCart.data) {
        this.shopCart.data.forEach(i => {
          if (i.menu_id == id) {
            beforeCount = i.number;
          }
        });
      }
      if (count > 0) {
        if (beforeCount > count) {
          this.subDish(id, index, beforeCount - count);
        } else if (beforeCount < count) {
          this.addDish(id, index, count - beforeCount);
        } else {
          return;
        }
      } else if (count == 0) {
        this.actMenus[index].count = 0;
        this.subDish(id, index, beforeCount - 1);
        this.subDish(id, index, 1);
      } else {
        this.shopNumber();
      }
    },
    isInShopCart(id) {
      var val = 0;
      if (this.shopCart.data) {
        for (var i = 0; i < this.shopCart.data.length; i++) {
          if (id == this.shopCart.data[i].menu_id) {
            val += this.shopCart.data[i].number;
          }
        }
      }
      return val;
    },
    editPackage(cartMenu) {
      if (cartMenu.category == "m") {
      } else {
        var data = {
          menu_id: cartMenu.menu_id,
          menus_id: cartMenu.menus_id,
          tags_id: cartMenu.tags_id,
          fill_price: cartMenu.fill_price,
          remark: cartMenu.remark
        };
        sessionStorage.setItem("editPackage", JSON.stringify(data));
        this.$router.push("/PackageEdit/" + cartMenu.id);
      }
    },
    shopNumber() {
      console.log(this.shopCart.data);
      if (this.shopCart.data) {
        this.actMenus.forEach(menu => {
          this.shopCart.data.forEach(shop => {
            if (menu.id === shop.menu_id) {
              menu.count = shop.number;
            }
          });
        });
      }
    },
    // 清空购物车
    chearShopcart() {
      this.$axios({
        method: "DELETE",
        url: this.$build + "/api/shopcart/takeClear",
        data: {
          code: localStorage.getItem("onlyCode")
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.getShopCart();
            this.getDishes();
            this.$toast({
              type: "success",
              message: res.data.message,
              duration: 1000
            });
          } else {
            this.$toast.allowMultiple();
          }
        })
        .catch(err => {
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar {
  z-index: 999;
}
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-sidebar {
  width: 25%;
  height: calc(100% - 3.125rem);
  padding-bottom: 3.125rem;
  background-color: #bbbbbb;
  float: left;
  overflow: auto;
}
/deep/ .van-sidebar-item {
  text-align: center;
  padding: 10px 10px 10px 8px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  margin: 15px 10px 15px 0px;
  border-radius: 0px 50px 50px 0px;
}
/deep/.van-sidebar-item--select::before {
  background: none;
}
/deep/ .van-sidebar-item--select {
  color: #fff;
  border-color: #000;
  background-color: #000;
}

/deep/ .van-divider {
  border-width: 2px;
}
/deep/ .van-info {
  border-color: #000;
}
/deep/ .van-dropdown-menu__bar {
  width: 120px;
  height: auto;
  background: none;
}
/deep/ .van-dropdown-menu__title {
  color: #fff;
}
/deep/ .van-dropdown-menu__title::after {
  right: -14px;
  margin-top: -10px;
  border: 6px solid;
  border-color: transparent transparent #ffffff #ffffff;
  opacity: 0.7;
}
/deep/ .van-dropdown-menu__title--down::after {
  margin-top: -2px;
}
/deep/ .van-stepper__minus--disabled,
.van-stepper__plus--disabled {
  background-color: #bbbbbb;
  border-radius: 7px;
}
/deep/ .van-stepper__input {
  background: none;
}
/deep/ .van-stepper__plus {
  border-radius: 7px;
}
/deep/ .van-stepper__minus::before {
  color: #fff;
  height: 2px;
}
/deep/ .van-stepper__plus::before {
  color: #fff;
  height: 2px;
}
/deep/ .van-stepper__plus::after {
  color: #fff;
  width: 2px;
}
/deep/ .van-stepper__minus {
  background-color: #bbbbbb;
  border-radius: 7px;
}
/deep/ .ShopCartBox .van-popup .van-cell {
  position: fixed;
  z-index: 999;
}
/deep/ .van-stepper__plus {
  background-color: var(--background-color, #555);
}
.van-badge__wrapper {
  float: left;
}
.Bigfont {
  width: 80%;
  font-size: 17px;
  font-weight: 600;
}
.Subname {
  width: 85%;
  font-size: 12px;
  color: #bbbbbb;
  margin-top: 2px;
}
.logn_icon {
  width: 50px;
}
.shopTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 56px 15px 10px;
  background-color: #fff;
  position: fixed;
  width: calc(100% - 30px);
  z-index: 99;
}
.shopTitle span {
  margin-left: 10px;
  font-size: 18px;
  font-weight: 600;
}
.menuImg {
  vertical-align: middle;
  border-radius: 5px;
  overflow: hidden;
}
.van-button__text {
  color: #fff;
}
.contentWrapper {
  padding-top: 116px;
  height: calc(100% - 176px);
}
.home {
  width: 100%;
  height: 100%;
  background-color: #f3f3f3;
}
.menuContent {
  width: 100%;
  height: 100%;
  flex: auto;
  background-color: #bbbbbb;
}
.menuContent1 {
  width: 100%;
  height: 100%;
  flex: auto;
}
.dishContent {
  width: 75%;
  height: calc(100% - 3.125rem);
  padding-bottom: 3.125rem;
  float: right;
  overflow: hidden;
  overflow-y: auto;
  margin-top: 2px;
  background-color: #fff;
}
.dishItem {
  width: calc(100% - 16px);
  margin: 10px 20px;
  height: 100px;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
  display: flex;
  overflow: hidden;
  align-items: center;
}
.itemInfo {
  width: calc(100% - 4.6875rem);
  flex: auto;
  display: -webkit-flex; /* Safari */
  display: flex;
  flex-direction: column;
}
.leftInfo {
  margin-left: 10px;
  width: 100%;
  min-height: 5rem;
  font-size: 14px;
}
.fontLine {
  overflow: hidden;
  word-break: break-all;
}
.price_num {
  width: 100%;
}
.icons {
  display: flex;
  width: 100%;
}
.itemIcon {
  text-align: right;
}
.enterIcon {
  position: absolute;
  top: 7px;
  right: 5px;
}
.flexBox {
  display: -webkit-flex; /* Safari */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.flexNone {
  flex: none;
}
.priceIcon {
  font-size: 14px;
}
.currentPrice {
  color: #fc1617;
  font-size: 18px;
  font-weight: 600;
}
.oldPrice {
  color: #bcbcbc;
  text-decoration: line-through;
}
.cart_left {
  width: 70%;
  height: 34px;
  line-height: 34px;
  float: left;
}
.cart_right {
  width: 30%;
  height: 34px;
  line-height: 26px;
  float: right;
  text-align: right;
  display: flex;
  justify-content: right;
}
.cart_right_btn {
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  color: #222;
  padding: 5px 35px;
  font-weight: 600;
  font-size: 18px;
}
.total_price {
  height: 34px;
  line-height: 34px;
  text-indent: 10px;
  font-size: 20px;
  font-weight: 600;
  text-align: right;
  margin-right: 10px;
}
.cartHeader {
  width: 100%;
  position: fixed;
  background: #fff;
  z-index: 10;
}
.cartDetail {
  width: 100%;
  height: auto;
  margin-top: 50px;
}
.cartItem {
  width: 90%;
  margin-left: 5%;
  position: relative;
}
.leftdot {
  position: absolute;
  width: 6px;
  height: 6px;
  left: -3.5%;
  top: 15px;
  background: linear-gradient(to right, #ffc914, #ffc813);
  border-radius: 50%;
}
.cart_dish {
  width: 100%;
  overflow: hidden;
}
.cart_dish_name {
  width: 80%;
  height: 60px;
  line-height: 60px;
  text-indent: 5px;
}
.cart_dish_icon {
  width: 80%;
  height: 40px;
  line-height: 40px;
}
.cart_dish_price {
  width: 20%;
  height: 35px;
  line-height: 35px;
  text-align: right;
  color: #aaa;
}
.cart_dish_des {
  width: calc(100% - 60px);
  height: 20px;
  line-height: 20px;
  font-size: 13px;
  color: #ccc;
}
.dish {
  display: flex;
}
.son_dish > .cart_dish_name {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_price {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_des {
  height: 18px;
  line-height: 18px;
  font-size: 12px;
}
.icon_group {
  height: 35px;
  line-height: 35px;
}
.realPrice {
  color: #fb2525;
  font-weight: 600;
}
.detailBar {
  width: 100%;
  height: 35px;
  line-height: 35px;
  text-align: center;
  color: #222;
  background-color: #ffc914;
  border-bottom: 1px solid #f3f3f3;
  position: relative;
}
.rightIcon {
  position: absolute;
  right: 5px;
  top: 5px;
}
.noflex {
  width: 70px;
  height: 70px;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
}
.dishItem_footer {
  display: flex;
  align-items: end;
}
.menu_name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
.reduceBtn,
.addBtn {
  border-radius: 8px;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/takeAway/TakeDishes.vue